import React from 'react';
import { useLabels } from 'src/StoreDataProvider';
import { NavigationProps } from './pagination.types';

const RightNavigation: (props: NavigationProps) => JSX.Element = ({
  onClick,
  currentPage,
  numberOfPages = 0,
}) => {
  const stylingForRightNavigation = (): React.CSSProperties => {
    if (!numberOfPages || currentPage + 1 === numberOfPages) {
      return { visibility: 'hidden' };
    }
    return {};
  };

  const labels = useLabels();
  return (
    <>
      <li style={stylingForRightNavigation()}>
        <button
          onClick={() => {
            onClick(
              currentPage < numberOfPages - 1 ? currentPage + 1 : currentPage
            );
          }}
          className={`pagination__icon-button`}
          data-cy="pagination-next"
          aria-label={labels.nextSearchPage}
        >
          <em className="icon-pfeil-rechts" />
        </button>
      </li>
      <li style={stylingForRightNavigation()}>
        <button
          onClick={() => {
            onClick(numberOfPages - 1);
          }}
          className={`pagination__icon-button`}
          data-cy="pagination-last"
          aria-label={labels.lastSearchPage}
        >
          <em className="icon-pfeil-ende" />
        </button>
      </li>
    </>
  );
};
export default RightNavigation;
